import { FormShowTemplate } from 'framework/form';
import BusinessOutcomes from '../../businessOutcomes/BusinessOutcomes';
import { Milestone, MilestoneStatus, OUTCOME_STATUS } from 'domain/shared/newProject';
import useOutcomesService from 'domain/projects/newProject/businessOutcomes/useOutcomesService';
import { BusinessOutcomesType } from 'domain/projects/newProject/businessOutcomes/types';
import { omit, set } from 'lodash';
import { useDashboardProjectDataContext } from 'domain/projects/newProject/context/DashboardProjectContext';
import { EditableListFormShowTemplate, NEW_ROW_ID_PREFIX } from 'framework/list';

const ProjectDashboardOutcomesWrapper = () => {
  const { data, refetch } = useDashboardProjectDataContext();
  const { businessOutcomesBatch, getOutcomesDashboardValidationSchema } = useOutcomesService();

  const milestones = data?.milestones?.map(
    ({ alias = '', title = '', status = MilestoneStatus.ACTIVE }: Milestone) => ({
      alias,
      title,
      status,
    }),
  );

  return (
    <FormShowTemplate
      isInitialsLoadingPosition
      submitFormFunc={async values => {
        await businessOutcomesBatch(
          data?.id!,
          values.businessOutcomes.map((v: BusinessOutcomesType) =>
            omit(
              {
                ...v,
                ...(v.id.toString().startsWith(NEW_ROW_ID_PREFIX) && { id: null, status: OUTCOME_STATUS.ACTIVE }),
              },
              '__typename',
            ),
          ),
        ).then(response => set(values, 'businessOutcomes', response));
      }}
      afterSubmit={{
        message: 'You are awesome! The Project outcomes section has been successfully updated.',
        execute: async () => {
          await refetch();
        },
      }}
      initialData={data}
      getValidationSchemaFunc={getOutcomesDashboardValidationSchema}
    >
      <EditableListFormShowTemplate
        listSource="businessOutcomes"
        localStorageKey={`project:${data?.id}:businessOutcomes`}
      >
        <BusinessOutcomes
          milestones={milestones}
          gridSx={{ pl: 1, pr: '0px !important' }}
          titleVariant="h4"
          accordionSx={{
            '.MuiAccordionSummary-root': { minHeight: '40px !important', pl: '4px', pr: 0, py: 1 },
            '.MuiSvgIcon-root': { fontSize: '20px' },
            '.MuiAccordionDetails-root .MuiGrid2-root': { px: 0 },
            '.MuiAccordionSummary-content': { m: 0 },
          }}
        />
      </EditableListFormShowTemplate>
    </FormShowTemplate>
  );
};
export default ProjectDashboardOutcomesWrapper;
